import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AppState } from 'src/app/state/app-state';
import { selectTotals } from 'src/app/state/selectors/current-contract.selectors';

@Component({
  selector: 'hb-buying-power-secure-amount',
  templateUrl: './buyingPowerSecureAmount.component.html',
  styleUrls: ['./buyingPowerSecureAmount.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BuyingPowerSecureAmountComponent implements OnInit, OnDestroy {
  public buyingPowerAmountIntegers: number;
  public buyingPowerAmountCents: string;
  public buyingPowerSecureAmount: number;
  public buyingPowerMarginAmount: number;
  private subscriptions = new Subscription();

  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    this.scanForTotals();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  public scanForTotals() {
    this.subscriptions.add(
      this.store
        .select(selectTotals)
        .pipe(filter((totals) => !!totals))
        .subscribe((totals) => {
          const [integers, cents] = totals.buyingPower.toString().split('.');
          this.buyingPowerSecureAmount = totals.buyingPowerSecureAmount;
          this.buyingPowerMarginAmount = totals.buyingPowerMarginAmount;
          this.buyingPowerAmountIntegers = Number(integers);
          this.buyingPowerAmountCents =
            cents && cents.length === 1
              ? `${cents}0`
              : cents
              ? cents.substring(0, 2)
              : '00';
        }),
    );
  }
}
